import React from 'react';
import Navbar from './Navbar';
import News from './News';
import Footer from './Footer';

const NewsPage = () => {
  return (
    <div className="news-page">
      <Navbar />
      <News />
      <Footer />
    </div>
  );
};

export default NewsPage;
